<template>
  <div>
    <IframeView :name="name" :url="`${baseUrl}/landing_page/silwir/`" :content-styles="contentStyles"
      :subContentStyles="subContentStyles" />
  </div>
</template>

<script setup>
import IframeView from '@/components/IframeView.vue';

const name = 'silwir';
const baseUrl = process.env.VUE_APP_WEBSITE_URL;
const contentStyles = '';
const subContentStyles = '';
</script>
